import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "isMultiSelect", "contentType", "selectedTags", "onChangeSelectedTags"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateTags, useFetchTags } from 'actions/tags';
import { setAlert } from 'actions/alerts';
import useUniqueId from 'hooks/useUniqueId';
import FormField, { useFormFieldContext } from 'components/FormField';
import MultiSelect from 'components/MultiSelect';
import { formatTags, tagIcon } from 'components/FormFields/utils';
import Stack from 'components/Stack';
import Flex from 'components/Flex';
import HintTooltip from 'components/HintTooltip';
import Text from 'components/Text';
import InlineList from 'components/InlineList';
import Pill from 'components/Pill';
var NEW_TAG_ID = 'new-tag';
var TagField = function TagField(_ref) {
  var isDisabled = _ref.isDisabled,
    _ref$isMultiSelect = _ref.isMultiSelect,
    isMultiSelect = _ref$isMultiSelect === void 0 ? false : _ref$isMultiSelect,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'playlist' : _ref$contentType,
    _ref$selectedTags = _ref.selectedTags,
    selectedTags = _ref$selectedTags === void 0 ? [] : _ref$selectedTags,
    onChangeSelectedTags = _ref.onChangeSelectedTags,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var _useCreateTags = useCreateTags(),
    createTags = _useCreateTags.createTags;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    tagInputValue = _useState2[0],
    setTagInputValue = _useState2[1];
  var _useFetchTags = useFetchTags(),
    providedTags = _useFetchTags.items,
    isLoading = _useFetchTags.isLoading,
    isError = _useFetchTags.isError;
  var uniqueId = useUniqueId();
  var commonTitleId = "common-".concat(uniqueId);
  var indeterminateTitleId = "indeterminate-".concat(uniqueId);

  // Filter all fetched tags by input value and remove already selected tags from dropdown
  var formattedTags = formatTags(providedTags.filter(function (tag) {
    return tag.name.includes(tagInputValue) && !selectedTags.some(function (selectedTag) {
      return selectedTag.value === tag.name;
    });
  }));
  var filteredTags = tagInputValue !== '' ? formattedTags.splice(0, 7) : [];

  // If current input was already a selected tag, prevent duplicate input
  var isDuplicate = selectedTags.some(function (t) {
    return t.value === tagInputValue;
  });
  if (isDuplicate) {
    filteredTags.unshift({
      id: '',
      name: t('alert_tag_already_added', {
        tag: tagInputValue
      }),
      value: "duplicate tag: ".concat(tagInputValue),
      icon: 'x',
      isDisabled: true
    });
  }

  // If no matching tag exists, show suggestion to add input as new tag in menu
  if (tagInputValue !== '' && !providedTags.filter(function (_ref2) {
    var name = _ref2.name;
    return name === tagInputValue;
  }).length) {
    filteredTags.unshift({
      id: NEW_TAG_ID,
      // This marks the tag as new
      name: t('actions_add_tag', {
        tag: tagInputValue
      }),
      value: tagInputValue,
      icon: tagIcon
    });
  }
  var createTag = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(newTagValue) {
      var tagValue, tag, _formatTags, _formatTags2, newTag;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            tagValue = newTagValue.trim();
            _context.prev = 1;
            _context.next = 4;
            return createTags([tagValue]);
          case 4:
            tag = _context.sent;
            _formatTags = formatTags(tag), _formatTags2 = _slicedToArray(_formatTags, 1), newTag = _formatTags2[0];
            return _context.abrupt("return", newTag);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            setAlert({
              key: 'add-my-team-playlist-tag',
              title: t('alert_tag_not_added', {
                tag: tagValue
              })
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function createTag(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var addTag = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newTag) {
      var tag, newSelection;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            tag = newTag;
            if (!(newTag.id === NEW_TAG_ID)) {
              _context2.next = 5;
              break;
            }
            _context2.next = 4;
            return createTag(newTag.value);
          case 4:
            tag = _context2.sent;
          case 5:
            newSelection = [].concat(_toConsumableArray(selectedTags), [tag]);
            onChangeSelectedTags({
              selectedItems: newSelection,
              itemsToAdd: tag,
              itemsToRemove: []
            });
            setTagInputValue('');
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function addTag(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var removeTag = function removeTag(tag) {
    var newSelection = selectedTags.filter(function (t) {
      return t.id !== tag.id;
    });
    onChangeSelectedTags({
      selectedItems: newSelection,
      itemsToAdd: [],
      itemsToRemove: tag
    });
  };
  var indeterminateTags = selectedTags.filter(function (tag) {
    return tag.isIndeterminate;
  });
  var commonTags = selectedTags.filter(function (tag) {
    return !tag.isIndeterminate;
  });
  return /*#__PURE__*/React.createElement(FormField, _extends({
    label: t('content_type_tag_plural')
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs",
    role: "group",
    "aria-labelledby": commonTitleId
  }, isMultiSelect && (commonTags.length > 0 || indeterminateTags.length > 0) && /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Text, {
    id: commonTitleId
  }, t('property_common')), /*#__PURE__*/React.createElement(HintTooltip, {
    content: t('hint_tags_common', {
      context: contentType,
      count: commonTags.length
    }),
    spacingLeft: "xs",
    vAlign: false
  })), /*#__PURE__*/React.createElement(MultiSelect, {
    inputValue: tagInputValue,
    selectedItems: commonTags,
    options: filteredTags,
    optionsLabel: t('content_type_tag_plural'),
    onInputValueChange: function onInputValueChange(input) {
      return setTagInputValue(input);
    },
    onSelectItem: addTag,
    onRemoveItem: removeTag,
    getMenuItemLabel: function getMenuItemLabel(item) {
      return item.name;
    },
    emptyMenuMessage: isLoading ? t('loading') : isError ? t('error_500') : '',
    isDisabled: isDisabled
  })), indeterminateTags.length > 0 && /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs",
    role: "group",
    "aria-labelledby": indeterminateTitleId
  }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Text, {
    id: indeterminateTitleId
  }, t('property_individual')), /*#__PURE__*/React.createElement(HintTooltip, {
    content: t('hint_tags_individual', {
      context: contentType,
      count: indeterminateTags.length
    }),
    spacingLeft: "xs",
    vAlign: false
  })), /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId
  }, isDisabled ? indeterminateTags.map(function (tag) {
    return /*#__PURE__*/React.createElement(Pill, {
      key: tag.id,
      icon: "tag"
    }, tag.name);
  }) : indeterminateTags.map(function (tag) {
    return /*#__PURE__*/React.createElement(Pill, {
      key: tag.id,
      icon: "tag",
      deleteLabel: t('actions_delete'),
      onDelete: function onDelete() {
        return removeTag({
          id: tag.id
        });
      }
    }, tag.name);
  })))));
};
export default TagField;